export const isStringsMatching = (firstString, secondString) =>
   firstString.toLowerCase().match(secondString.toLowerCase())

export const removeSpacesFromGivenString = (str: string): string =>
   str.replace(/\s+/g, '')

export const getFormattedIdFromStrings = (
   strings: string[],
   binder = '::'
): string =>
   strings.reduce((accumilator, eachString) =>
      accumilator ? `${accumilator}${binder}${eachString}` : eachString
   )
